<template lang="pug">
  .wt-upload-image
    BLoading(:active.sync="loading" :is-full-page="false")
    slot(name="label")
    figure.image.image-preview.mt-3(v-if="previewImageData")
      img(
        ref="preview"
        :src="previewImageData"
        :alt="entity+' image'"
      )
    BUpload.image-upload-input.custom-image-upload-input(
      v-if="!previewImageData"
      multiple
      drag-drop
      @input="previewImage"
      native
      accept="image/jpeg,image/gif,image/png"
    )
      .content.has-text-centered.upload-text-info
          BIcon(icon="upload" size="is-medium")
          p Drop your files here, or click to upload, and see a preview.
          p Note: for best results, upload a square image sized 256 x 256 px.
    .level.is-mobile.mt-4
      .level-item(v-if="showCancelButton")
        WtButton(
          color="red"
          @click.native="reset"
          is-text
        ) Cancel
      .level-item(v-if="showSaveButton")
        WtButton.save-button.is-fullwidth(
          is-rounded
          color="green"
          @click.native="saveImage"
          fullwidth
        ) Save Image
      .level-item.custom-level-item(v-if="showEditButton")
        WtButton(
          outlined
          color="grey"
          @click.native="clearPreview"
          size="medium"
        ) Edit
</template>

<script>
import { mapActions } from "vuex";
import imageCompression from "browser-image-compression";
import WtButton from "@@/WtButton/WtButton";

export default {
  name: "WtUploadImage",

  components: {
    WtButton
  },

  props: {
    entity: {
      type: String,
      default: "member"
    },

    currentImage: {
      type: [String, Blob],
      default: ""
    },

    showSave: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      newLogo: [],
      previewImageData: "",
      dataURL: null,
      imageCompressionError: false
    };
  },

  computed: {
    showSaveButton() {
      return (
        this.showSave &&
        this.previewImageData !== this.currentImage &&
        this.previewImageData !== ""
      );
    },

    showCancelButton() {
      return (
        (this.currentImage && this.previewImageData !== this.currentImage) ||
        (!this.currentImage && this.previewImageData)
      );
    },

    showEditButton() {
      return this.currentImage && this.previewImageData === this.currentImage;
    }
  },

  watch: {
    currentImage: function(newVal) {
      this.previewImageData = newVal;
    }
  },

  mounted() {
    this.$nextTick(() => (this.previewImageData = this.currentImage));
  },

  methods: {
    ...mapActions(["snackBar"]),

    async previewImage(file) {
      file = file[0] || false;

      const options = {
        maxSizeMB: 10, // apiv3 maxsize
        maxWidthOrHeight: 1920,
        useWebWorker: true
      };
      let blob = null;
      try {
        blob = await imageCompression(file, options);

        this.dataURL = await imageCompression.getDataUrlFromFile(blob);
        this.newPhoto = blob;
        // send the compressed image to the apiv3, otherwise file size errors occur
        this.$emit("updateImage", this.newPhoto);

        this.showReplace = true;
        this.previewImageData = this.dataURL;
      } catch (error) {
        this.imageCompressionError = true;
      }
    },

    clearPreview() {
      this.previewImageData = "";
      this.$emit("updateImage", null);
    },

    saveImage() {
      this.$emit("update:currentImage", this.previewImageData);
      this.$emit("saveImage");
    },

    reset() {
      this.previewImageData = this.currentImage;
      this.$emit("updateImage", null);
    }
  }
};
</script>

<style lang="sass">
.wt-upload-image
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  .image-preview
    max-width: 200px
    max-height: 200px
    overflow: hidden // the image will overflow if it wants to

  .image-upload-input
    .upload-draggable
      margin: auto
      padding: 3rem 1rem 3rem 1rem
  .custom-image-upload-input
    display: flex
    align-items: center
    justify-content: center
</style>
